export default __webpack_public_path__ + "static/media/GregNwosu.33c08096.png";